import willieChat from'../images/willieChat.png'
import phoebeChat from'../images/phoebeChat.png'
import lakeBG from'../images/lake_bg.png'
import phoebeStuckTree from'../images/phoebeStuckTree.gif'
import phoebeStuckTreeGettingOut from'../images/phoebeStuckTreeGettingOut.png'
import dickWatching from'../images/dickWatching.png'
import dickWatching2 from'../images/dickWatching2.png'
import dickWatching3 from'../images/dickWatching3.png'
import dickWatching4 from'../images/dickWatching4.png'
import dickWatching5 from'../images/dickWatching5.png'
import dickWatching6 from'../images/dickWatching6.png'
import dickWatching7 from'../images/dickWatching7.png'
import dickWatching8 from'../images/dickWatching8.png'
import dickWatching9 from'../images/dickWatching9.png'
import dickWatching10 from'../images/dickWatching10.png'
import dickWatching11 from'../images/dickWatching11.png'
import evilAngel1 from'../images/evilAngel1.png'
import evilAngel2 from'../images/evilAngel2.png'
import evilAngel3 from'../images/evilAngel3.png'
import phoebeBurger from'../images/phoebeBurger.png'
import phoebeUpsideDown from'../images/phoebeUpsideDown.gif'
import phoebeUpsideDown2 from'../images/phoebeUpsideDown2.png'
import phoebeUpsideDown3 from'../images/phoebeUpsideDown3.png'
import phoebeUpsideDown4 from'../images/phoebeUpsideDown4.png'
import phoebeUpsideDown5 from'../images/phoebeUpsideDown5.png'
import phoebeUpsideDown6 from'../images/phoebeUpsideDown6.png'
import phoebeUpsideDown7 from'../images/phoebeUpsideDown7.png'
import phoebeCunnilingus from'../images/phoebeCunnilingus.png'
import phoebeCunnilingus2 from'../images/phoebeCunnilingus2.png'
import phoebeCunnilingus3 from'../images/phoebeCunnilingus3.png'
import phoebeCunnilingus4 from'../images/phoebeCunnilingus4.png'
import phoebeCunnilingus5 from'../images/phoebeCunnilingus5.png'
import phoebeCunnilingus6 from'../images/phoebeCunnilingus6.png'
import phoebeCunnilingus7 from'../images/phoebeCunnilingus7.png'
import phoebeCunnilingus8 from'../images/phoebeCunnilingus8.png'
import phoebeCunnilingus9 from'../images/phoebeCunnilingus9.png'
import phoebeCunnilingus10 from'../images/phoebeCunnilingus10.png'
import phoebeCunnilingus11 from'../images/phoebeCunnilingus11.png'
import phoebeCunnilingus12 from'../images/phoebeCunnilingus12.png'
import phoebeCunnilingus13 from'../images/phoebeCunnilingus13.png'
import phoebeCunnilingus14 from'../images/phoebeCunnilingus14.png'
import phoebeCunnilingus15 from'../images/phoebeCunnilingus15.png'
import phoebeCunnilingus16 from'../images/phoebeCunnilingus16.png'
import phoebeCunnilingus17 from'../images/phoebeCunnilingus17.png'
import phoebeCunnilingus18 from'../images/phoebeCunnilingus18.png'
import phoebeCunnilingus19 from'../images/phoebeCunnilingus19.png'
import phoebeCunnilingus20 from'../images/phoebeCunnilingus20.png'
import phoebeCunnilingus21 from'../images/phoebeCunnilingus21.png'
import phoebeCunnilingus22 from'../images/phoebeCunnilingus22.png'
import phoebeCunnilingus23 from'../images/phoebeCunnilingus23.png'
import phoebeCunnilingus24 from'../images/phoebeCunnilingus24.png'
import phoebeCunnilingus25 from'../images/phoebeCunnilingus25.png'
import phoebeCunnilingus26 from'../images/phoebeCunnilingus26.png'
import phoebeCunnilingus27 from'../images/phoebeCunnilingus27.png'
import phoebeCunnilingus28 from'../images/phoebeCunnilingus28.png'
import phoebeCunnilingus29 from'../images/phoebeCunnilingus29.png'
import phoebeCunnilingus30 from'../images/phoebeCunnilingus30.png'
import phoebeCunnilingus31 from'../images/phoebeCunnilingus31.png'
import phoebeCumming from'../images/phoebeCumming.gif'
import phoebeCumming2 from'../images/phoebeCumming2.png'
import phoebeCumming3 from'../images/phoebeCumming3.png'
import phoebeCumming4 from'../images/phoebeCumming4.png'
import phoebeCumming5 from'../images/phoebeCumming5.png'
import phoebeCumming6 from'../images/phoebeCumming6.png'
import phoebeCumming7 from'../images/phoebeCumming7.png'
import phoebeCumming8 from'../images/phoebeCumming8.png'
import phoebeCumming9 from'../images/phoebeCumming9.png'
import phoebeCumming10 from'../images/phoebeCumming10.png'
import phoebeCumming11 from'../images/phoebeCumming11.png'
import phoebeCumming12 from'../images/phoebeCumming12.png'
import phoebeCumming13 from'../images/phoebeCumming13.png'
import phoebeCumming14 from'../images/phoebeCumming14.png'
import phoebeCumming15 from'../images/phoebeCumming15.png'
import theWets from'../images/theWets.png'
import evilAngelCunnilingus from'../images/evilAngelCunnilingus.png'
import evilAngelCunnilingus2 from'../images/evilAngelCunnilingus2.png'
import evilAngelCunnilingus3 from'../images/evilAngelCunnilingus3.png'
import evilAngelCunnilingus4 from'../images/evilAngelCunnilingus4.png'
import evilAngelCunnilingus5 from'../images/evilAngelCunnilingus5.png'
import phoebeMessage from'../audio/phoebeMessage.mp3'
import phoebeMessage2 from'../audio/phoebeMessage2.mp3'
import characters from'./characters';
import achievements from'./achievements';
import gallery from'./gallery';
import natureAmbient from'../m/natureAmbient.js'
import discovering from'../m/discovering.js'
import quirkyForest from'../m/quirkyForest.js'
import buzzing from'../m/buzzing.js'
import poof from'../m/poof.js'
import thinking from'../m/thinking.js'
import shiny from'../m/shiny.js'
import quirkyForest2 from'../m/quirkyForest2.js'
import grass from'../m/grass.js'
import fight from'../m/fight.js'
import vinyl from'../m/vinyl.js'
import vibrator from'../m/vibrator.js'
import hollow from'../m/phoebe/hollow.js'
import hollow3 from'../m/phoebe/hollow3.js'
import gig from'../m/phoebe/gig.js'
import gig2 from'../m/phoebe/gig2.js'
import moan0 from'../m/phoebe/moan0.js'
import moan1 from'../m/phoebe/moan1.js'
import moan2 from'../m/phoebe/moan2.js'
import moan3 from'../m/phoebe/moan3.js'
import moan4 from'../m/phoebe/moan4.js'
import moan5 from'../m/phoebe/moan5.js'
import moan6 from'../m/phoebe/moan6.js'
import moan7 from'../m/phoebe/moan7.js'
import moan8 from'../m/phoebe/moan8.js'
import moan9 from'../m/phoebe/moan9.js'
import moan10 from'../m/phoebe/moan10.js'
import moan11 from'../m/phoebe/moan11.js'
import moan12 from'../m/phoebe/moan12.js'
import moan13 from'../m/phoebe/moan13.js'
import moan14 from'../m/phoebe/moan14.js'
import moan15 from'../m/phoebe/moan15.js'
import breathing from'../m/phoebe/breathing.js'
import hemhem from'../m/phoebe/hemhem.js'
import hmm from'../m/phoebe/hmm.js'
import notificationSound from'../m/notification.js'

const chapter3 = [
  {chat:true, from:{name:"Phoebe", photo:phoebeChat},
   messages: [
     {text:"Did you do the sex ed homework?", from:'messageFromHer', answers:["Um... yeah","Wasn't it only for girls?"]},
     {text:"Oh.. Fuck! Sorry😭", from:'messageFromHer', answered:"Um... yeah"},
     {text:"It's not quite what I meant ahah", from:'messageFromHer', answered:"Um... yeah"},
     {text:"Hmmm... Idk", from:'messageFromHer', answered:"Wasn't it only for girls?"},
     {text:"Probably..", from:'messageFromHer', answered:"Wasn't it only for girls?"},
     {text:"Anyway you kinda did it last class hehe😈", from:'messageFromHer', answered:"Wasn't it only for girls?", endofAnswer:true},
     {audio:phoebeMessage, from:'messageFromHer'},
     {text:"And my room really isn’t private enough...", from:'messageFromHer'},
     {text:"Anyone can come in basically at any moment", from:'messageFromHer', answers:["Same...","What about your bathroom?"]},
     {text:"And I can't even go to the bathroom!", from:'messageFromHer', answered:"Same..."},
     {text:"The locker is broken", from:'messageFromHer', answered:"Same..."},
     {text:"And even if it wasn't, Ursula has been stuck there for 2 hours or sth..", from:'messageFromHer', answered:"Same..."},
     {text:"Well, it could be an option", from:'messageFromHer', answered:"What about your bathroom?"},
     {text:"But the locker isn't working", from:'messageFromHer', answered:"What about your bathroom?"},
     {text:"And even if it did, Ursula has been stuck there for 2 hours or sth...", from:'messageFromHer', answered:"What about your bathroom?", endofAnswer:true},
     {text:"Hope it's diarrhea!", from:'messageFromHer'},
     {text:"Or... wait..", from:'messageFromHer'},
     {text:"OH GOD! I don't even want to think abt it🙈", from:'messageFromHer'},
     {text:"I just wish I had my own place...", from:'messageFromHer'},
     {text:"Or at least a little bit of privacy", from:'messageFromHer'},
     {text:"I just can't relax in here", from:'messageFromHer'},
     {text:"Shit...", from:'messageFromHer'},
     {text:"I'll see if it gets any better at night...", from:'messageFromHer'},
     {text:"Good night!✨", from:'messageFromHer', endOfChat:true},
  ]
  },
  {blackScreen:true, txt:["<h2>*Morning*</h2>"]},
  {chat:true, from:{name:"Phoebe", photo:phoebeChat},
   messages: [
     {text:"Hey!", from:'messageFromHer'},
     {text:"How could I forget!", from:'messageFromHer'},
     {text:"My horoscope says I need some private time today, only best friends are allowed!♊", from:'messageFromHer'},
     {text:"So I think I came(I didn't) up with sth!", from:'messageFromHer'},
     {text:"I need a quiet place with no one to disturb me", from:'messageFromHer'},
     {text:"I know the place!", from:'messageFromHer'},
     {text:"But with no one disturbing me..", from:'messageFromHer'},
     {text:"I might need your help", from:'messageFromHer'},
     {text:"Please please please💃🏼🎤", from:'messageFromHer', answers:["Okay, but how?","Do I have a choice?"]},
     {text:"Thank you!!!", from:'messageFromHer', answered:"Okay, but how?"},
     {text:"Well, I guess you could close the chat and ghost me haha🚩🚩", from:'messageFromHer', answered:"Do I have a choice?"},
     {text:"But please please don’t!", from:'messageFromHer', answered:"Do I have a choice?"},
     {text:"Okay", from:'messageFromMe', answered:"Do I have a choice?"},
     {text:"Thanks!", from:'messageFromHer', answered:"Do I have a choice?", endofAnswer:true},
     {text:"Sooo, you know turtle lake, right?", from:'messageFromHer'},
     {text:"It's in the park nearby the s.h.i.t. college", from:'messageFromHer'},
     {text:"It's so quiet and calm there", from:'messageFromHer'},
     {text:"I used to go there a lot while preparing for the exams...", from:'messageFromHer'},
     {text:"But of course there are a few people here and there sometimes..", from:'messageFromHer'},
     {text:"SO here comes.. YOU", from:'messageFromHer'},
     {text:"You'll watch that no one’s around, while I’m..", from:'messageFromHer'},
     {text:"Um.. doing my homework!", from:'messageFromHer'},
     {text:"And no we won't be late for the class, I promise!🤞", from:'messageFromHer'},
     {audio:phoebeMessage2, from:'messageFromHer', endOfChat:true},
  ]
  },

  {blackScreen:true, txt:["<h2>*On the Turtle lake*</h2>"]},

  {novel:true, background:lakeBG, startCoordinates:100,
  script:[
    {phoebesComfort:true, set:1, achievementCondition: true, achievementConditionSet:true},
    {char:characters["empty"],  position:"center", coordinates: 80, speed:3, transitionMode:"slow",
    phrases:[
      {text:"Okay, so, here is the lake, but...", ambientStart:natureAmbient, loopTimeAmbient:300, ambientSettings:[0.2, 1200]},
    ]
    },
    {char:characters["empty"],  position:"center", coordinates: 20, speed:4, transitionMode:"slow",
    phrases:[
      {text:"Where is Phoebe?"},
    ]
    },
    {char:characters["phoebe"],  position:"center", coordinates: 40, speed:1.4,
    phrases:[
      {text:"Dick!", soundEffect:hollow, soundEffectVolume:0.2},
    ]
    },
    {scene:true, img:phoebeStuckTree, start:true, time:300, gallery:gallery[22], musicStart:discovering, loopTime:2000, musicSettings:[0.3, 2200], soundEffectPre:hollow3, soundEffectVolume:0.2},
    {scene:true, name:characters["phoebe"].name, position:"center",
    phrases:[
      {text:"Dick! Is that you?"},
      {text:"Help me please!!"},
      {text:"I’m stuck..."},
      {text:"You can take my waist or.. hips and.."},
    ]},
    {scene:true, endOfScene:true, time:10, skip:true},
    {scene:true, img:phoebeStuckTreeGettingOut, start:true, actionEvent:true, time:300, skip:true, skipFirstTap:true},
    {scene:true, name:characters["phoebe"].name, position:"center",
    phrases:[
      {text:"Uh-huh"},
      {text:"Okay, now, on the count of three - pull!"},
      {text:"THREE!", actionStart:["Tap"], musicEnd:true, musicSettings:2000},
    ]},
    {endOfNovel:true}
  ]},

  {novel:true, background:lakeBG, startCoordinates:0,
  script:[
    {char:characters["phoebe"],  position:"right", coordinates: 20, speed:2, transitionMode:"slow",
    phrases:[
      {text:"Ahahah", emotion:characters["phoebe"].standingLaughingWild, achievement:achievements[16], ambientStart:natureAmbient, loopTimeAmbient:300, ambientSettings:[0.2, 1200], musicStart:quirkyForest, loopTime:20000, musicSettings:[0.3, 2200], soundEffect:gig, soundEffectVolume:0.5},
      {text:"Thank you!", emotion:characters["phoebe"].standingNeutralWild},
      {text:"I was just... looking for birds..", emotion:characters["phoebe"].standingNeutralWild},
    ]
    },
    {char:characters["dick"],  position:"left", coordinates: 15, speed:1,
    phrases:[
      {text:"...", emotion:characters["dick"].standingNeutral, answers:["Did you find any?", "What's that on your face?"]},
    ]
    },
      {option:"Did you find any?", start:true},
      {char:characters["dick"],  position:"left", coordinates: 15, speed:1,
      phrases:[
        {text:"Did you find any?", emotion:characters["dick"].standingNeutral},
      ]
      },
      {char:characters["phoebe"],  position:"right", coordinates: 20, speed:1,
      phrases:[
        {text:"Nope, definitely no birds there...", emotion:characters["phoebe"].standingNeutralWild},
        {text:"Just trash and cigarette butts", emotion:characters["phoebe"].standingFrustratedWild},
      ]
      },
      {option:"Did you find any?", endOfOption:true},

      {option:"What's that on your face?", start:true},
      {char:characters["dick"],  position:"left", coordinates: 15, speed:1,
      phrases:[
        {text:"What's that on your face?", emotion:characters["dick"].standingNeutral},
      ]
      },
      {char:characters["phoebe"],  position:"right", coordinates: 20, speed:1,
      phrases:[
        {text:"That's my camo!", emotion:characters["phoebe"].standingSmilingWild},
        {text:"To hide in the grass, if anything.", emotion:characters["phoebe"].standingEyebrowUpWild},
      ]
      },
      {option:"What's that on your face?", endOfOption:true, endOfOptions:true},

      {char:characters["phoebe"],  position:"right", coordinates: 20, speed:1,
      phrases:[
        {text:"All right, well.. I’m ready!", emotion:characters["phoebe"].standingSmilingWild},
      ]
      },
      {char:characters["dick"],  position:"left", coordinates: 15, speed:1,
      phrases:[
        {text:"You’re gonna… I mean.. right?", emotion:characters["dick"].standingEmbarassedQuestion},
      ]
      },
      {char:characters["phoebe"],  position:"right", coordinates: 20, speed:1,
      phrases:[
        {text:"Well.. Nature always helped me...", emotion:characters["phoebe"].standingNeutralWild},
        {text:"I'm not sure there is a better place for me", emotion:characters["phoebe"].standingSmilingWild},
        {text:"Just.. I really hope no one sees it", emotion:characters["phoebe"].standingEmbarassedWild},
        {text:"So stand here and watch out for people...", emotion:characters["phoebe"].standingSmilingWild},
        {text:"If you see someone, scream.. m-m...", emotion:characters["phoebe"].standingThinkingWild},
        {text:"Just scream okay!", emotion:characters["phoebe"].standingLaughingWild},
        {text:"And one more thing...", emotion:characters["phoebe"].standingNeutralWild},
        {text:"Promise you won’t peek, okay?", emotion:characters["phoebe"].standingEyebrowUpWild, answers:["All right, I promise", "Well.. I’ll do my best."]},
      ]
      },

      {option:"All right, I promise", start:true},
      {phoebesComfort:true, plus:-0.1},
      {char:characters["phoebe"],  position:"right", coordinates: 20, speed:1,
      phrases:[
        {text:"Thank you!", emotion:characters["phoebe"].standingSmilingWild},
      ]
      },
      {option:"All right, I promise", endOfOption:true},

      {option:"Well.. I’ll do my best.", start:true},
      {phoebesComfort:true, plus:-0.05},
      {char:characters["phoebe"],  position:"right", coordinates: 20, speed:1,
      phrases:[
        {text:"Thanks..", emotion:characters["phoebe"].standingEyebrowUpNeutralWild, note:"Phoebe feels uncomfortable"},
      ]
      },
      {option:"Well.. I’ll do my best.", endOfOption:true, endOfOptions:true},

      {char:characters["phoebe"],  position:"right", coordinates: 20, speed:1,
      phrases:[
        {text:"Well um.. I’m gonna go then", emotion:characters["phoebe"].standingEmbarassedWild},
        {text:"And don’t eavesdrop!", emotion:characters["phoebe"].standingLaughingWild},
      ]
      },
    {endOfNovel:true, musicContinue:true}
  ]},

  {novel:true, background:dickWatching, startCoordinates:0,
  script:[
    {char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"Okay, I'm starting!", answers:["Good luck!", "Okay, I'm watching!"], ambientStart:natureAmbient, loopTimeAmbient:300, ambientSettings:[0.2, 1200], musicStart:quirkyForest, loopTime:20000, musicSettings:[0.3, 2200]},
    ]
    },
    {option:"Good luck!", start:true},
    {changeBG:true, img:dickWatching2, smooth:true},
    {char:characters["dick"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"Good luck!"},
    ]
    },
    {char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"Thanks! Ahah"},
    ]
    },
    {option:"Good luck!", endOfOption:true},

    {option:"Okay, I'm watching!", start:true},
    {char:characters["dick"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"Okay, I'm watching!"},
    ]
    },
    {changeBG:true, img:dickWatching2, smooth:true},
    {char:characters["dick"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"I mean... not you..."},
    ]
    },
    {char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"Ahahah, yeah, you better not!"},
    ]
    },
    {option:"Okay, I'm watching!", endOfOption:true, endOfOptions:true},

    {changeBG:true, img:dickWatching, smooth:true},
    {char:characters["empty"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"..."},
      {text:"*birds singing*", ambientChangeSettings:[0.6, 700]},
      {text:"*BZZZ*", ambientChangeSettings:[0.2, 700], soundEffect:buzzing, soundEffectVolume:0.5},
    ]
    },
    {changeBG:true, img:dickWatching11, smooth:true},
    {char:characters["dick"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"Oh, god, what is that?!!"},
      {text:"I hate bugs!"},
    ]
    },
    {char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"Don't worry about it!"},
      {text:"Probably some bee pollinating a flower"},
    ]
    },
    {changeBG:true, img:dickWatching, smooth:true},
    {char:characters["dick"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"Okay..."},
    ]
    },
    {changeBG:true, img:dickWatching3, smooth:true},
    {char:characters["empty"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"*Hmm.. She is so quiet*"},
    ]
    },
    {changeBG:true, img:dickWatching4, smooth:true},
    {char:characters["empty"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"*Is she really masturbating right behind me..*"},
      {text:"*Is she doing it external or...*"},
    ]
    },
    {changeBG:true, img:dickWatching5, smooth:true},
    {char:characters["empty"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"*WHAT THE?!*", soundEffectPre:poof, soundEffectVolume:0.2},
    ]
    },
    {endOfNovel:true}
  ]},

  {novel:true, background:evilAngel1, startCoordinates:0,
  script:[
    {char:characters["evilRyder"],  position:"center", coordinates: 0, speed:1.7,
    phrases:[
      {text:"I know you’d really like to find out, Richard", musicStart:thinking, loopTime:5000, musicSettings:[0.3, 2200]},
      {text:"So what are you waiting for?"},
      {text:"She is doing it right behind your back"},
    ]
    },
    {changeBG:true, img:evilAngel2, smooth:true},
    {char:characters["angelRyder"],  position:"center", coordinates: 100, speed:1.7, transitionMode:"slow",
    phrases:[
      {text:"Richard, no!"},
      {text:"She just needs some privacy and emotional comfort"},
    ]
    },
    {changeBG:true, img:evilAngel3, smooth:true},
    {char:characters["angelRyder"],  position:"center", coordinates: 100, speed:1.7, transitionMode:"slow",
    phrases:[
      {text:"And you’re helping her get it!"},
      {text:"Don't look, it'll ruin the moment!"},
    ]
    },
    {char:characters["evilRyder"],  position:"center", coordinates: 0, speed:1.7, transitionMode:"slow", changeBGTransition:evilAngel1,
    phrases:[
      {text:"Don't listen to her Richard, I know she wants you to look"},
      {text:"And I see you want it too, don't you?"},
    ]
    },
    {changeBG:true, img:evilAngel2, smooth:true},
    {char:characters["angelRyder"],  position:"center", coordinates: 100, speed:1.7, transitionMode:"slow",
    phrases:[
      {text:"No! Don't listen to her!"},
      {text:"I know you want to look, but you can explore it in a different, more safe way for both of you"},
    ]
    },
    {changeBG:true, img:evilAngel3, smooth:true},
    {char:characters["angelRyder"],  position:"center", coordinates: 100, speed:1.7, transitionMode:"slow",
    phrases:[
      {text:"Just use your imagination!"},
    ]
    },
    {endOfNovel:true}
  ]},

  {novel:true, background:dickWatching6, startCoordinates:0,
  script:[
    {char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
    phrases:[
      {text:"Mmmhm...", ambientStart:natureAmbient, startPointAmbient:10, loopTimeAmbient:300, ambientSettings:[0.2, 1200], soundEffect:moan0, soundEffectVolume:0.05},
    ]
  },
  {char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
  phrases:[
    {text:"<small><i>*fast breathing*</small></i>", soundEffect:breathing, soundEffectVolume:0.3},
  ]
},
  {char:characters["dick"],  position:"center", coordinates: 0, speed:1,
  phrases:[
    {text:"Fuck! What do I do?...", answers:["Fantasize", "Peek"], timer:3},
  ]
},

{option:"Fantasize", start:true},
{scene:true, img:phoebeBurger, start:true, time:300, gallery:gallery[23], soundEffectPre:shiny, soundEffectVolume:0.3, ambientChangeSettings:[0.6, 1000]},
{scene:true, name:characters["phoebe"].name, position:"center", dialogCoordinates:"55vh",
phrases:[
  {text:"How long has it been since your last meal?", achievement:achievements[17]},
  {text:"You hurried so much to help me, I bet you skipped breakfast"},
  {text:"Wanna eat it?"},
  {text:"It's juicy and full of nutrients", soundEffectPre:gig2, soundEffectVolume:0.7},
  {text:"There is a sauce I made special for you"},
]},
{scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true, dialogCoordinates:"60vh", ambientChangeSettings:[0.2, 1000]},
{char:characters["dick"],  position:"center", coordinates: 0, speed:1, changeBGTransition:dickWatching10,
phrases:[
  {text:"..."},
]
},
{changeBG:true, img:dickWatching7, smooth:true},
{char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
phrases:[
  {text:"Dick?"},
]
},
{option:"Fantasize", endOfOption:true},

{option:"Skip", start:true},
{char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
phrases:[
  {text:"Dick?"},
]
},
{changeBG:true, img:dickWatching7, smooth:true},
{option:"Skip", endOfOption:true},

{option:"Peek", start:true},
{phoebesComfort:true, plus:-0.47},
{changeBG:true, img:dickWatching8, smooth:true},
{char:characters["dick"],  position:"center", coordinates: 0, speed:1,
phrases:[
  {text:"Okay, just one small peek..."},
]
},
{changeBG:true, img:dickWatching7, smooth:true},
{char:characters["phoebe"],  position:"center", coordinates: 100, speed:1, transitionMode:"slow",
phrases:[
  {text:"Dick, don't!!!", note:"Phoebe feels uncomfortable", soundEffect:hemhem, soundEffectVolume:0.3},
  {text:"It's not helping!"},
  {text:"Watch the perimeter!"},
]
},
{char:characters["dick"],  position:"center", coordinates: 0, speed:1, transitionMode:"slow", changeBGTransition:dickWatching9,
phrases:[
  {text:"..."},
]
},
{option:"Peek", endOfOption:true, endOfOptions:true},
{char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
phrases:[
  {text:"Did you see anyone?", musicStart:quirkyForest2, loopTime:100, musicSettings:[0.3, 2200]},
]
},
{changeBG:true, img:dickWatching8, smooth:true},
{char:characters["dick"],  position:"center", coordinates: 0, speed:1,
phrases:[
  {text:"No! No one! Sector clear!"},
]
},
{changeBG:true, img:dickWatching7, smooth:true},
{char:characters["phoebe"],  position:"center", coordinates: 0, speed:1,
phrases:[
  {text:"Fuck!"},
  {text:"I just.. I don't understand.."},
  {text:"What am I doing wrong?!"},
  {text:"Can you.. um.. maybe help me..? Please?"},
  {text:"I mean..."},
  {text:"You're the most experienced one now after the last class I guess"},
]
},
{scene:true, img:phoebeUpsideDown, start:true, time:300, gallery:gallery[24], ambientChangeSettings:[0.05, 1000]},
{scene:true, name:characters["phoebe"].name, position:"center", dialogCoordinates:"65vh",
phrases:[
  {text:"Like the view? ahah"},
  {text:"Mhmm...", soundEffectPre:moan1, soundEffectVolume:0.1},
  {text:"It feels really good, but I just can't finish.."},
  {text:"I- I just.. I have tried almost everything!"},
]},
{scene:true, img:phoebeUpsideDown2, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
  {text:"Even this fast and slow thing you did with Stacy..."},
]},
{scene:true, img:phoebeUpsideDown4, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
  {text:"It doesn’t work for me"},
  {text:"Like at all…"},
]},
{scene:true, img:phoebeUpsideDown3, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
  {text:"And I really wanna cum"},
]},
{scene:true, img:phoebeUpsideDown4, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
  {text:"What’s wrong...", answers:["Is this pose okay for you?", "I guess it just works different for everyone"]},
]},

{option:"Is this pose okay for you?", start:true},
{scene:true, img:phoebeUpsideDown3, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
  {text:"Well.. yeah"},
  {text:"Kinda"},
]},
{scene:true, img:phoebeUpsideDown4, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
  {text:"I'm not sure..."},
  {text:"I did it like this in the shower"},
]},
{option:"Is this pose okay for you?", endOfOption:true},

{option:"I guess it just works different for everyone", start:true},
{scene:true, img:phoebeUpsideDown5, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
  {text:"Well, yeah… you’re right"},
]},
{scene:true, img:phoebeUpsideDown6, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
  {text:"Oh, I miss the times when I did it like this in the shower"},
]},
{option:"I guess it just works different for everyone", endOfOption:true, endOfOptions:true},


{scene:true, img:phoebeUpsideDown7, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
  {text:"And there used to be this showerhead"},
  {text:"It did it just right..."},
  {text:"It was so wet, and I always imagined someone eating me out"},
]},
{scene:true, img:phoebeUpsideDown6, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
  {text:"Umm.."},
  {text:"Hang on a sec"},
]},
{scene:true, endOfScene:true, time:10, skip:true, soundEffectPre:grass, soundEffectVolume:0.05},
{scene:true, img:phoebeCunnilingus, start:true, time:1700, skip:true, skipFirstTap:true, gallery:gallery[25]},
{scene:true, name:characters["phoebe"].name, position:"center", dialogCoordinates:"8vh",
phrases:[
  {text:"Yeah, this pose might be more comfortable"},
]},
{scene:true, img:phoebeCunnilingus2, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
  {text:"You know... It still turns me on..."},
  {text:"Just thinking about someone's tongue on my pussy ahah.."},
]},
{scene:true, img:phoebeCunnilingus3, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
  {text:"Umm"},

]},
{scene:true, img:phoebeCunnilingus4, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
  {text:"And I thought maybe..."},
]},
{scene:true, img:phoebeCunnilingus5, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
  {text:"You could help me?"},
]},
{scene:true, img:phoebeCunnilingus6, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
  {text:"As a friend helps a friend I mean..."},
]},
{scene:true, img:phoebeCunnilingus7, changeScene:true, slowMode:true},
{scene:true, name:characters["empty"].name, position:"center",
phrases:[
  {text:"...", soundEffectPre:poof, soundEffectVolume:0.2},
]},
{endOfNovel:true}
  ]},

{novel:true, background:evilAngelCunnilingus, startCoordinates:100,
script:[
  {char:characters["angelRyder"],  position:"center", coordinates: 100, speed:1.7,
  phrases:[
    {text:"Richard, no!", musicStart:thinking, loopTime:5000, musicSettings:[0.3, 2200]},
    {text:"Unprotected oral sex is very dangerous!"},
    {text:"You can catch basically any std through it"},
  ]
  },
  {char:characters["evilRyder"],  position:"center", coordinates: 0, speed:1.7, transitionMode:"slow",
  phrases:[
    {text:"Don't even listen to her!"},
    {text:"She’s always been a party pooper!"},
    {text:"Just look at her, she wants it so much, how could you say no?"},
  ]
  },
  {char:characters["angelRyder"],  position:"center", coordinates: 100, speed:1.7, changeBGTransition:evilAngelCunnilingus2,
  phrases:[
    {text:"You should make sure you both are healthy before doing it!"},
    {text:"Or use a dental dam!"},
  ]
  },
  {char:characters["evilRyder"],  position:"center", coordinates: 0, speed:1.7, transitionMode:"slow",
  phrases:[
    {text:"Shut up you, bitch!", musicEnd:true, musicSettings:300, soundEffect:vinyl, soundEffectVolume:0.3},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 50, speed:1.7, transitionMode:"slow", changeBGTransition:evilAngelCunnilingus3,
  phrases:[
    {text:"...", soundEffect:fight, soundEffectVolume:0.5},
  ]
  },
  {changeBG:true, img:evilAngelCunnilingus4},
  {char:characters["empty"],  position:"center", coordinates: 50, speed:1.7, transitionMode:"slow", changeBGTransition:evilAngelCunnilingus3,
  phrases:[
    {text:"*fight sounds*"},
  ]
  },
  {changeBG:true, img:evilAngelCunnilingus5, smooth:true},
  {char:characters["evilRyder"],  position:"center", coordinates: 50, speed:1.7, transitionMode:"slow",
  phrases:[
    {text:"Don't you dare saying no to her now, Richard!"},
  ]
  },
  {endOfNovel:true}
]},

{novel:true, background:lakeBG, startCoordinates:0,
script:[
{scene:true, img:phoebeCunnilingus8, start:true, time:300, skipFirstTap:true, gallery:gallery[26]},
{scene:true, name:characters["phoebe"].name, position:"center", dialogCoordinates:"60vh",
phrases:[
{text:"So, could you?", answers:["Yeah, I can","Okay, sure"], ambientStart:natureAmbient, loopTimeAmbient:300, ambientSettings:[0.1, 1200]},
]},
{option:"Yeah, I can", start:true},
{scene:true, name:characters["phoebe"].name, position:"center", dialogCoordinates:"8vh",
phrases:[
{text:"I feel you're worried..."},
]},
{option:"Yeah, I can", endOfOption:true},

{option:"Okay, sure", start:true},
{scene:true, name:characters["phoebe"].name, position:"center", dialogCoordinates:"8vh",
phrases:[
{text:"I feel you're worried..."},
]},
{option:"Okay, sure", endOfOption:true, endOfOptions:true},

{scene:true, img:phoebeCunnilingus9, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"Me too..."},
{text:"It's.. my first time"},
{text:"I mean... with someone"},
]},
{scene:true, img:phoebeCunnilingus8, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"I think you can come closer", musicStart:quirkyForest2, loopTime:100, musicSettings:[0.3, 2200]},
]},
{scene:true, img:phoebeCunnilingus11, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"Umm..."},
]},
{scene:true, img:phoebeCunnilingus10, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center", dialogCoordinates:"60vh",
phrases:[
{text:"So, does it look like a burger to you? Ahaha", answers:["Well, yeah, kinda","Not really"]},
]},

{option:"Well, yeah, kinda", start:true},
{phoebesComfort:true, plus:0.01},
{scene:true, name:characters["phoebe"].name, position:"center", dialogCoordinates:"8vh",
phrases:[
{text:"Told ya! haha", soundEffectPre:gig2, soundEffectVolume:0.5},
]},
{scene:true, img:phoebeCunnilingus10, changeScene:true, slowMode:true},
{option:"Well, yeah, kinda", endOfOption:true},

{option:"Not really", start:true},
{scene:true, img:phoebeCunnilingus12, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center", dialogCoordinates:"8vh",
phrases:[
{text:"Oh?", soundEffectPre:hmm, soundEffectVolume:0.3},
]},
{scene:true, img:phoebeCunnilingus10, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"Well, I guess it's the angle thing!"},
]},
{option:"Not really", endOfOption:true, endOfOptions:true},

{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"Please, be gentle..."},
]},
{scene:true, img:phoebeCunnilingus13, changeScene:true, slowMode:true},
{scene:true, name:characters["empty"].name, position:"center",
phrases:[
{text:"...", actionStart:["Hold", ["35vw","65vh"]], autoPlay:1300, musicChangeSettings:[0.25, 700], musicChangeSpeed:[0.98,700], ambientChangeSpeed:[0.98,700]},
]},
{scene:true, img:phoebeCunnilingus14, changeScene:true, slowMode:true, gallery:gallery[27]},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"Mmph!", musicChangeSettings:[0.3, 1000], ambientChangeSpeed:[1,200], musicChangeSpeed:[1,200], soundEffectPre:moan11, soundEffectVolume:0.2},
]},
{scene:true, img:phoebeCunnilingus10, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"Wow..."},
{text:"This feels good"},
]},
{scene:true, img:phoebeCunnilingus12, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center", dialogCoordinates:"60vh",
phrases:[
{text:"It doesn't smell bad, right?", answers:["No!","It's fine"], timer:2.5, autoPlay:2000},
]},

{option:"No!", start:true},
{phoebesComfort:true, plus:0.01},
{scene:true, img:phoebeCunnilingus10, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center", dialogCoordinates:"8vh",
phrases:[
{text:"Alright ahah", achievement:achievements[18], soundEffectPre:gig, soundEffectVolume:0.15},
{text:"I was just worried.."},
]},
{option:"No!", endOfOption:true},

{option:"It's fine", start:true},
{phoebesComfort:true, plus:-0.1},
{scene:true, name:characters["phoebe"].name, position:"center", dialogCoordinates:"8vh",
phrases:[
{text:"Um.. Okay...", note:"Phoebe feels uncomfortable", soundEffectPre:hmm, soundEffectVolume:0.23},
]},
{option:"It's fine", endOfOption:true},

{option:"Skip", start:true},
{phoebesComfort:true, plus:-0.1},
{scene:true, name:characters["phoebe"].name, position:"center", dialogCoordinates:"8vh",
phrases:[
{text:"Anyways.. Hope it's not...", note:"Phoebe feels uncomfortable", soundEffectPre:hmm, soundEffectVolume:0.23},
]},
{option:"Skip", endOfOption:true, endOfOptions:true},

{scene:true, img:phoebeCunnilingus13, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"Can you go a bit lower now?", actionStart:["Slider", ["35vw","55vh"], "down", "200", "low"], autoPlay:900},
]},
{scene:true, img:phoebeCunnilingus15, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"Yeeess, right here", soundEffectPre:moan7, soundEffectVolume:0.22},
{text:"It feels even better than that showerhead", autoPlay:1600},
{text:"So gentle..", autoPlay:900},
]},
{scene:true, img:phoebeCunnilingus16, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"And to the sides", actionStart:["Slider", ["35vw","65vh"], "right","150","low", 3]},
]},
{scene:true, img:phoebeCunnilingus17, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"Ah!", actionStart:["Slider", ["65vw","65vh"], "left","150","medium", 3], soundEffectPre:moan3, soundEffectVolume:0.22},
]},
{scene:true, img:phoebeCunnilingus18, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"Yes, keep going like this", actionStart:["Hold", ["35vw","65vh"], , , , 3.5], musicChangeSettings:[0.25, 700], musicChangeSpeed:[0.98,700], ambientChangeSpeed:[0.98,700], soundEffectPre:moan9, soundEffectVolume:0.22},
]},
{scene:true, img:phoebeCunnilingus19, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"Yeah and a little higher", actionStart:["Slider", ["50vw","50vh"], "up","250","low", 2], musicChangeSettings:[0.3, 500], musicChangeSpeed:[1,200], ambientChangeSpeed:[1,200], soundEffectPre:moan7, soundEffectVolume:0.22},
]},
{scene:true, img:phoebeCunnilingus20, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"MMmm", soundEffectPre:moan10, soundEffectVolume:0.22},
{text:"And a bit on the left", actionStart:["Slider", ["70vw","60vh"], "left","150","medium", 1.7]},
]},
{scene:true, img:phoebeCunnilingus21, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"YeeeAH", soundEffectPre:moan4, soundEffectVolume:0.2},
{text:"And a bit lower again, pleeease", actionStart:["Slider", ["70vw","50vh"], "down","250","low", 1.7]},
]},
{scene:true, img:phoebeCunnilingus19, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"YeeEs, right here", soundEffectPre:moan7, soundEffectVolume:0.2},
]},
{scene:true, img:phoebeCunnilingus22, changeScene:true, slowMode:true},
{scene:true, name:characters["empty"].name, position:"center",
phrases:[
{text:"*BZZZ*", vibration:[200, 200, 300, 200, 400, 200, 1000], autoPlay:700, soundEffectPre:vibrator, soundEffectVolume:0.5},
]},
{scene:true, img:phoebeCunnilingus23, changeScene:true, slowMode:true},
{scene:true, name:characters["dick"].name, position:"center",
phrases:[
{text:"Huh? Where did it come from?", autoPlay:2500},
]},
{scene:true, img:phoebeCunnilingus24, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"Ms. Ryder gave it to me..", autoPlay:1500},
{text:"This little bee is just gonna help us a little"},
]},
{scene:true, name:characters["dick"].name, position:"center",
phrases:[
{text:"So that’s where this sound was coming from...", autoPlay:2500},
]},
{scene:true, img:phoebeCunnilingus25, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"Ahah, I was just checking if it works", autoPlay:1500},
]},
{scene:true, img:phoebeCunnilingus26, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"Please, don't stop", actionStart:["Hold", ["45vw","75vh"], , , , 3.3], musicChangeSettings:[0.2, 700], musicChangeSpeed:[0.95,700], ambientChangeSpeed:[0.95,700] },
]},
{scene:true, img:phoebeCunnilingus27, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"God, I'm so wet...", autoPlay:700, soundEffectPre:moan10, soundEffectVolume:0.4},
{text:"HArder!", actionStart:["Hold", ["25vw","65vh"], , , , 3], musicChangeSettings:[0.25, 500], musicChangeSpeed:[0.98,300], ambientChangeSpeed:[0.98,300]},
]},
{scene:true, img:phoebeCunnilingus28, changeScene:true, slowMode:true, gallery:gallery[28]},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"YEES!", achievement:achievements[19], autoPlay:2000, musicChangeSettings:[0.3, 500], musicChangeSpeed:[1,200], ambientChangeSpeed:[1,200], soundEffectPre:moan12, soundEffectVolume:0.7},
{text:"Your tongue's driving me wild..."},
{text:"Please, keep going..", actionStart:["Slider", ["65vw","50vh"], "left","200","hard", 1.8], autoPlay:500},
]},
{scene:true, img:phoebeCunnilingus29, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"Mhmmm", actionStart:["Slider", ["35vw","40vh"], "down","220","hard", 2.3], soundEffectPre:moan6, soundEffectVolume:0.7},
]},
{scene:true, img:phoebeCunnilingus30, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"OH GOD!!", achievement:achievements[21], achievementConditionValue:[true], soundEffectPre:moan5, soundEffectVolume:0.8},
]},
{scene:true, img:phoebeCunnilingus31, changeScene:true, slowMode:true},
{scene:true, name:characters["phoebe"].name, position:"center",
phrases:[
{text:"Dick...", autoPlay:800},
{text:"I'm...", autoPlay:1400},
{text:"I'm so close!", autoPlay:600},
]},
{scene:true, endOfScene:true, time:10, skip:true},
{endOfNovel:true}
]},

{novel:true, background:phoebeCumming, startCoordinates:100,
script:[
  {scene:true, img:phoebeCumming, start:true, time:300, skip:true, gallery:gallery[29], ambientStart:natureAmbient, loopTimeAmbient:300, ambientSettings:[0.3, 1200]},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"But.. can you close your eyes, please?"},
  {text:"It's just.. My o-face", answers:["Close eyes","Keep watching"], timer:3, phoebeUncomfortableCondition:[0.50, "Close eyes", ["Close eyes(no finish)", 3]]},
  ]},
  {option:"Close eyes", start:true},
  {scene:true, blackScreen:true, startBS:true, wait:800},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"Yes, yes, yes", ambientChangeSettings:[0.1, 1000], vibration:[1200], soundEffectPre:moan7, soundEffectVolume:0.5},
  {text:"Oh my god!"},
  {text:"Mmmm", vibration:[300, 200, 300, 500, 300, 1000], soundEffectPre:moan11, soundEffectVolume:1},
  {text:"Nnnngh", soundEffectPre:moan13, soundEffectVolume:1},
  {text:"Ooof", vibration:[700, 300, 300, 200, 300, 200, 1000, 600, 1000, 100, 400, 100, 200], soundEffectPre:moan14, soundEffectVolume:1},
  ]},
  {scene:true, img:phoebeCumming15, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"Fuuck.."},
  {text:"You can open your eyes now...", vibrationCancel:true},
  ]},
  {scene:true, blackScreen:true, endBS:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"That was good...", ambientChangeSettings:[0.2, 1000]},
  ]},
  {scene:true, img:phoebeCumming2, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"I guess the homework is done", achievement:achievements[20]},
  {text:"Thank you for helping"},
  {text:"And for listening to me.."},
  {text:"Now I know what I really like.."},
  ]},
  {scene:true, img:phoebeCumming4, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"When I'm heard and cared for.."},
  ]},
  {scene:true, img:phoebeCumming3, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"Well and being eaten out, no shit ahahah"},
  ]},
  {scene:true, img:phoebeCumming13, changeScene:true},
  {scene:true, name:characters["empty"].name, position:"center",
  phrases:[
  {text:"*ding ding*", vibration:[200, 200, 200], soundEffectPre:notificationSound, soundEffectVolume:0.2},
  {text:"Shit!"},
  ]},
  {scene:true, img:phoebeCumming14, changeScene:true},
  {scene:true, name:characters["empty"].name, position:"center",
  phrases:[
  {text:"What time is it?!"},
  {text:"Did we.."},
  ]},
  {scene:true, img:phoebeCumming12, changeScene:true},
  {scene:true, name:characters["empty"].name, position:"center",
  phrases:[
  {text:"We skipped the lesson! FUUCK"},
  {text:"Give me my phone please"},
  ]},
  {option:"Close eyes", endOfOption:true},

  {option:"Keep watching", start:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"Mmmm", soundEffectPre:moan6, soundEffectVolume:0.3},
  {text:"...", soundEffectPre:moan13, soundEffectVolume:0.3},
  {text:"...", soundEffectPre:moan15, soundEffectVolume:0.8},
  ]},
  {scene:true, img:phoebeCumming5, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"Fuck"},
  {text:"Uff"},
  ]},
  {scene:true, img:phoebeCumming6, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"I was so close.."},
  {text:"I guess for some reason I just don't feel comfortable enough, like emotionally"},
  ]},
  {scene:true, img:phoebeCumming7, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"Well, but at least now I know what I like"},
  ]},
  {scene:true, img:phoebeCumming8, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"Soo I guess the homework is done!"},
  {text:"Thanks for helping me"},
  ]},
  {scene:true, img:phoebeCumming9, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"It felt so nice.."},
  ]},
  {scene:true, img:phoebeCumming8, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"Both the help and.. the whole process hehe"},
  ]},
  {scene:true, img:phoebeCumming10, changeScene:true},
  {scene:true, name:characters["empty"].name, position:"center",
  phrases:[
  {text:"*ding ding*", vibration:[200, 200, 200], soundEffectPre:notificationSound, soundEffectVolume:0.2},
  {text:"Shit!"},
  ]},
  {scene:true, img:phoebeCumming11, changeScene:true},
  {scene:true, name:characters["empty"].name, position:"center",
  phrases:[
  {text:"What time is it?!"},
  {text:"Did we.."},
  ]},
  {scene:true, img:phoebeCumming7, changeScene:true},
  {scene:true, name:characters["empty"].name, position:"center",
  phrases:[
  {text:"We skipped the lesson! FUUCK"},
  {text:"Give me my phone please"},
  ]},
  {option:"Keep watching", endOfOption:true},

  {option:"Skip", start:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"Mmmm", soundEffectPre:moan6, soundEffectVolume:0.3},
  {text:"...", soundEffectPre:moan13, soundEffectVolume:0.3},
  {text:"...", soundEffectPre:moan15, soundEffectVolume:0.8},
  ]},
  {scene:true, img:phoebeCumming5, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"Fuck"},
  {text:"Uff"},
  ]},
  {scene:true, img:phoebeCumming6, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"I was so close.."},
  {text:"I guess for some reason I just don't feel comfortable enough, like emotionally"},
  ]},
  {scene:true, img:phoebeCumming7, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"Well, but at least now I know what I like"},
  ]},
  {scene:true, img:phoebeCumming8, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"Soo I guess the homework is done!"},
  {text:"Thanks for helping me"},
  ]},
  {scene:true, img:phoebeCumming9, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"It felt so nice.."},
  ]},
  {scene:true, img:phoebeCumming8, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"Both the help and.. the whole process hehe"},
  ]},
  {scene:true, img:phoebeCumming10, changeScene:true},
  {scene:true, name:characters["empty"].name, position:"center",
  phrases:[
  {text:"*ding ding*", vibration:[200, 200, 200], soundEffectPre:notificationSound, soundEffectVolume:0.2},
  {text:"Shit!"},
  ]},
  {scene:true, img:phoebeCumming11, changeScene:true},
  {scene:true, name:characters["empty"].name, position:"center",
  phrases:[
  {text:"What time is it?!"},
  {text:"Did we.."},
  ]},
  {scene:true, img:phoebeCumming7, changeScene:true},
  {scene:true, name:characters["empty"].name, position:"center",
  phrases:[
  {text:"We skipped the lesson! FUUCK"},
  {text:"Give me my phone please"},
  ]},
  {option:"Skip", endOfOption:true},

  {option:"Close eyes(no finish)", start:true},
  {scene:true, blackScreen:true, startBS:true, wait:800},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"Mmmm", ambientChangeSettings:[0.1, 1000], soundEffectPre:moan6, soundEffectVolume:0.3},
  {text:"...", soundEffectPre:moan13, soundEffectVolume:0.3},
  {text:"...", soundEffectPre:moan15, soundEffectVolume:0.8},
  {text:"Uff"},
  {text:"I think you can open your eyes now..."},
  ]},
  {scene:true, img:phoebeCumming6, changeScene:true},
  {scene:true, blackScreen:true, endBS:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"I was so close..", ambientChangeSettings:[0.2, 1000]},
  {text:"I guess for some reason I just don't feel comfortable enough, like emotionally"},
  ]},
  {scene:true, img:phoebeCumming7, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"Well, but at least now I know what I like"},
  ]},
  {scene:true, img:phoebeCumming8, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"Soo I guess the homework is done!"},
  {text:"Thanks for helping me"},
  ]},
  {scene:true, img:phoebeCumming9, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"It felt so nice.."},
  ]},
  {scene:true, img:phoebeCumming8, changeScene:true},
  {scene:true, name:characters["phoebe"].name, position:"center",
  phrases:[
  {text:"Both the help and.. the whole process hehe"},
  ]},
  {scene:true, img:phoebeCumming10, changeScene:true},
  {scene:true, name:characters["empty"].name, position:"center",
  phrases:[
  {text:"*ding ding*", vibration:[200, 200, 200], soundEffectPre:notificationSound, soundEffectVolume:0.2},
  {text:"Shit!"},
  ]},
  {scene:true, img:phoebeCumming11, changeScene:true},
  {scene:true, name:characters["empty"].name, position:"center",
  phrases:[
  {text:"What time is it?!"},
  {text:"Did we.."},
  ]},
  {scene:true, img:phoebeCumming7, changeScene:true},
  {scene:true, name:characters["empty"].name, position:"center",
  phrases:[
  {text:"We skipped the lesson! FUUCK"},
  {text:"Give me my phone please"},
  ]},
  {option:"Close eyes(no finish)", endOfOption:true, endOfOptions:true},

  {endOfNovel:true}
]},

{groupChat:true, from:{name:"WET Squad", photo:theWets, members:3 },
 messages: [
   {text:"Guys, where are you?", from:'messageFromThem', name:"Willinator", avatar:willieChat, answers:["I was helping Phoebe","I overslept"]},
   {text:"Oh, hope you both are fine",from:'messageFromThem', name:"Willinator", avatar:willieChat, answered:"I was helping Phoebe"},
   {text:"Yeeeeah, dude, sure..",from:'messageFromThem', name:"Willinator", avatar:willieChat, answered:"I overslept"},
   {text:"Phoebe too? hehe",from:'messageFromThem', name:"Willinator", avatar:willieChat, answered:"I overslept", endofAnswer:true},
   {text:"The class has just ended AND IT WAS INSANE",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Shit! What did we miss?",from:'messageFromThem', name:"Phoebe", avatar:phoebeChat},
   {text:"Soo, to start with..",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"There was a cool story from Violet and her heel masturbation(she even prepared some kind of guide)",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"It's really well structured.. with all the nuances",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"And Howard.. well, you don't wanna know",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Then we were learning male anatomy and guess who got to practice???",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"That was so FUCKING(more like jerking tbh) COOL…",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Ms. Ryder explained the male orgasm...",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"With my help… If u know what I mean",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"It's like she has a major in it...",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Doesn’t mind acting with her feet and stuff...",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Wait, are you saying she gave you a..",from:'messageFromThem', name:"Phoebe", avatar:phoebeChat},
   {text:"Footjob?",from:'messageFromThem', name:"Phoebe", avatar:phoebeChat},
   {text:"Oh, I knew you wouldn’t believe it!",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Fuck!! It's sick!!",from:'messageFromThem', name:"Phoebe", avatar:phoebeChat},
   {text:"And I guess she was so upset since Dick didn't come(pun intended)",from:'messageFromThem', name:"Phoebe", avatar:phoebeChat},
   {text:"Teachers pet;3",from:'messageFromThem', name:"Phoebe", avatar:phoebeChat},
   {text:"Ahhah, YEAH, she asked where he was btw",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"I'm telling you!!!",from:'messageFromThem', name:"Phoebe", avatar:phoebeChat},
   {text:"So, do you have any notes from the lecture?",from:'messageFromThem', name:"Phoebe", avatar:phoebeChat},
   {text:"No. Much more better! I have a video of it!",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"I'll send it in a few mins!",from:'messageFromThem', name:"Willinator", avatar:willieChat},
   {text:"Thank you!",from:'messageFromThem', name:"Phoebe", avatar:phoebeChat},
   {text:"I think me and Richard now have some catching up to do, right?",from:'messageFromThem', name:"Phoebe", avatar:phoebeChat, answers:["Of course!","Should we?"]},
   {text:"Yaay! I'm so excited! I've always wondered how this.. thing🍆 works..",from:'messageFromThem', name:"Phoebe", avatar:phoebeChat, answered:"Of course!"},
   {text:"I knew you wouldn't want to upset Ms. Ryder ahaha",from:'messageFromThem', name:"Phoebe", avatar:phoebeChat, answered:"Of course!"},
   {text:"Deal then😏",from:'messageFromThem', name:"Phoebe", avatar:phoebeChat, answered:"Of course!"},
   {text:"Well, of course!",from:'messageFromThem', name:"Phoebe", avatar:phoebeChat, answered:"Should we?"},
   {text:"Otherwise Ms. Ryder will be so upset with you, you don't want it ahaha",from:'messageFromThem', name:"Phoebe", avatar:phoebeChat, answered:"Should we?"},
   {text:"Plus I think that could be... fun",from:'messageFromThem', name:"Phoebe", avatar:phoebeChat, answered:"Should we?", endofAnswer:true},
   {text:"Good luck! Gotta go, grandma just cooked my fav soup! Such a day!",from:'messageFromThem', name:"Willinator", avatar:willieChat, endOfChat:true}
]
},

{blackScreen:true, txt:["<h2>It's the end of the third chapter! I hope you enjoyed it! </h2> <br/> Feel free to share your thoughts in comments;)","<h2>Chapter four(Catch-up session) is already available on my Patreon, along with updates on what’s coming next, devlogs, WIPs, feedback polls, and exclusive content!</h2>","<h2>Your support means a lot — it would really help me keep improving the game and creating more content! </br> Thank you!💖</h2>"], end:true},

];

export default chapter3;
